<template>
	<div class="mainWrapper pi">
		<h1>Purchase Invoice Detail</h1>
		<div class="po-details" v-if="pi">
			<div class="first-row">
				<div class="details"><span>PI NUMBER</span> <br />{{ pi.code }}</div>
				<div class="details"><span>PO NUMBER</span> <br />{{ pi.purchase_order.code }}</div>
				<div class="details">
					<span>APPROVED BY</span> <br />
					{{ pi.author.name }}
				</div>

				<div class="details">
					<span>BRAND</span> <br />
					{{ brand }}
				</div>

				<div class="details">
					<span>CREATED</span> <br />
					{{ convertTime(pi.createdAt) }}
				</div>
			</div>

			<div class="list">
				<div class="piItemList header">
					<div>BD CODE</div>
					<div>BARCODE</div>
					<div>PRODUCT NAME</div>
					<div>REQUESTED QUANTITY</div>
					<div>QUANTITY</div>
					<div>PRICE</div>
					<div>RECEIVED DATE</div>
					<div>REMARK</div>
				</div>

				<div v-for="(item, index) of piProducts" v-bind:key="index" class="piItemList">
					<div>{{ item.product.bd_code }}</div>
					<div>{{ item.product.barcode }}</div>
					<div>{{ item.product.name }}</div>
					<div>{{ getRequestQty(item.product._id) }}</div>
					<div>{{ item.qty }}</div>
					<div>{{ getItemPrice(item) }}</div>
					<div>{{ convertTime(item.received_date) }}</div>
					<div>{{ item.remark }}</div>
				</div>
			</div>

			<div class="po-detail-buttons-wrapper">
				<div class="align-left">
					<b-button type="is-dark" icon-left="arrow-left" @click="back()">BACK</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PurchaseOrderDetails',
	data: function() {
		return {
			piId: this.$route.params.id, //id from get url
			brand: this.$route.params.brand, //brand
			pi: null,
			piProducts: null,
			poProducts: null
		}
	},
	mounted: async function() {
		// Get all the PI
		var piData = {
			id: this.piId,
			populate: ['author', 'purchase_order']
		}

		const apiGetPI = await this.$api.getPI({ data: piData })

		this.pi = apiGetPI.data.list[0]

		// Get PO Item Details
		const poResult = await this.getPoDetail({
			id: this.pi.purchase_order._id
		})

		this.poProducts = poResult.data.purchase_order_items

		var data = {
			purchase_invoice: this.piId,
			populate: ['product'],
			limit: 1000
		}

		const apiGetPIProduct = await this.$api.getPIDetail({ data })

		this.piProducts = apiGetPIProduct.data.list
	},

	methods: {
		getItemPrice: function(data) {
			const product = data.product

			if (product.commission > 0 || (product.original_price && product.original_price < 2)) {
				return product.price
			} else {
				return product.original_price
			}
		},

		// Get request quantity
		getRequestQty: function(data) {
			const result = this.poProducts.filter(po_items => {
				if (po_items.product == data) {
					return po_items.qty
				}
			})

			return result ? result[0].qty : ''
		},

		getPoDetail: async function(data) {
			return await this.$api.getPODetail({ data })
		},

		back: function() {
			this.$router.push('/pi')
		},
		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY')
		}
	}
}
</script>

<style scoped>
@import '../styles/PI.css';
</style>
